import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import cn from 'classnames';
import { IconButton } from '@asphalt-react/button';
import { Cross, CaretDown, CaretUp } from '@asphalt-react/iconpack';
import { propsUtil } from '@asphalt-react/helper';
import matchSorter from 'match-sorter';
import { Manager, Reference, Popper } from 'react-popper';
import { sendStyles } from '@asphalt-react/context';
import Checkbox from '@asphalt-react/checkbox';
import Avatar from '@asphalt-react/avatar';
import Tag from '@asphalt-react/tag';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Dropdown__q-j4p {\n  --dropdown-font-color: var(--text-secondary, hsla(219, 42%, 24%, 1));\n  --dropdown-hover-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  --dropdown-icon-color: var(--icon-primary, hsla(220, 42%, 24%, 1));\n  position: relative;\n  width: 320px;\n  line-height: 1;\n  box-sizing: border-box;\n}\n.Dropdown__q-j4p.stretch__-Nl-b {\n  width: 100%;\n}\n.l__JFFF0 {\n  font-size: var(--body-l, 1.13rem);\n}\n.m__We65K {\n  font-size: var(--body-m, 1rem);\n}\n.s__EEErq {\n  font-size: var(--body-s, 0.88rem);\n}\n.SelectionBox__xtWZU {\n  border: var(--border-width, 1px)\n    var(--interactive-border-solid, solid hsla(220, 22%, 76%, 1));\n  border-radius: var(--roundness-1, 2px);\n  line-height: initial;\n  color: var(--dropdown-font-color);\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  outline: none;\n  background-color: var(--interactive-fill-default, hsla(0, 0%, 100%, 1));\n  cursor: default;\n  box-sizing: border-box;\n}\n\n.SelectionBox__xtWZU.s__EEErq {\n  min-height: 32px;\n  padding: 0.187rem 0.75rem;\n}\n.SelectionBox__xtWZU.m__We65K {\n  min-height: 40px;\n  padding: 0.28rem 0.75rem;\n}\n.SelectionBox__xtWZU.l__JFFF0 {\n  min-height: 48px;\n  padding: 0.375rem 0.75rem;\n}\n\n.SelectionBox__xtWZU:hover {\n  background-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n}\n.SelectionBox__xtWZU:focus,\n.SelectionBox__xtWZU:focus-within {\n  background-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  border-color: var(--interactive-focus, hsla(219, 42%, 18%, 1));\n}\n.SelectionBox__xtWZU.invalid__gmMCu {\n  border-color: var(--interactive-border-support, hsla(12, 92%, 36%, 1));\n}\n.SelectionBox__xtWZU.placeholder__m4YPi {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n}\n.SelectionBox__xtWZU.disabled__d3-CY {\n  background-color: var(--interactive-disabled, hsla(0, 0%, 86%, 1));\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n  border: none;\n  pointer-events: none;\n}\n.Dropdown__q-j4p.disabled__d3-CY {\n  cursor: not-allowed;\n}\n.selection__2v4Kb {\n  overflow: auto;\n}\n.inputFieldWrap__CvB0G {\n  width: 100%;\n}\n.inputField__kfOVU {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: inherit;\n}\n.inputField__kfOVU::-moz-placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU::placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU.applyTextColor__qLmOU::-moz-placeholder {\n  color: var(--dropdown-font-color);\n  opacity: 1;\n}\n.inputField__kfOVU.applyTextColor__qLmOU::placeholder {\n  color: var(--dropdown-font-color);\n  opacity: 1;\n}\n.inputField__kfOVU:focus::-moz-placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU:focus::placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU:disabled::-moz-placeholder {\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n}\n.inputField__kfOVU:disabled::placeholder {\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n}\n.iconsContainer__vcUeh {\n  display: inline-flex;\n  align-items: center;\n}\n.iconsContainer__vcUeh svg path {\n  fill: var(--dropdown-icon-color);\n}\n\n.Popover__Vya9r {\n  --popover-border-radius: var(--roundness-1, 2px);\n  background-color: var(--background-fill-primary, hsla(0, 0%, 100%, 1));\n  width: 100%;\n  padding: 5px 0;\n  z-index: 1;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.Popover__Vya9r.popBot__UMGcE {\n  border-bottom-left-radius: var(--popover-border-radius);\n  border-bottom-right-radius: var(--popover-border-radius);\n  box-shadow: var(--shadow-low, 0px 0px 10px 0px hsla(222, 42%, 6%, 0.1));\n}\n.Popover__Vya9r.popTop__QIRll {\n  border-top-left-radius: var(--popover-border-radius);\n  border-top-right-radius: var(--popover-border-radius);\n  box-shadow: 0 0px 6px 0 hsla(222, 4%, 6%, 0.1);\n}\n.caretIcon__oY455 {\n  font-size: 0;\n}\n.SelectionBox__xtWZU.disabled__d3-CY .caretIcon__oY455 path {\n  fill: var(--icon-disabled, hsla(0, 0%, 62%, 1));\n}\n.emptyState__WrKDO {\n  display: flex;\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  padding: 0.1rem 0.75rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n.listbox__xIBYn {\n  max-height: 180px;\n  overflow-y: auto;\n  list-style-type: none;\n  margin: 0;\n  width: 100%;\n  outline: none;\n  padding: 0;\n  box-sizing: border-box;\n}\n.listItem__8-ELC {\n  width: 100%;\n  --listItem-hover-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  --listItem-selected-color: var(\n    --interactive-fill-active,\n    hsla(220, 17%, 93%, 1)\n  );\n  --listItem-font-color: var(--text-secondary, hsla(219, 42%, 24%, 1));\n  color: var(--listItem-font-color);\n  margin: 0;\n  padding: 8px 16px;\n  cursor: default;\n  box-sizing: border-box;\n}\n.listWithAvatar__S9P3V {\n  display: flex;\n  align-items: center;\n}\n.nameWithAvatar__mhr9h {\n  margin: 0 5px;\n}\n.selectedItemsSpace__hGP1P {\n  background-color: var(--interactive-fill-default, hsla(0, 0%, 100%, 1));\n  height: auto;\n  width: 100%;\n  max-height: 75px;\n  padding-bottom: 5px;\n  margin-bottom: 4px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.tagItem__GiVdT {\n  margin: 2px;\n  display: inline-flex;\n  white-space: nowrap;\n}\n.listWithMultiselect__jxBI1 {\n  display: flex;\n  align-items: center;\n}\n\n/* \n* Pointer events none is added to stop event propagation from checkbox container back to the user \n*/\n\n.itemWithMultiselect__A52ld {\n  pointer-events: none;\n  display: inline-flex;\n  margin-right: 10px;\n}\n.selectedItem__10mDT {\n  background-color: var(--listItem-selected-color);\n}\n.activeItem__6r9mj {\n  background-color: var(--listItem-hover-color);\n}\n.disabledItem__MdN3V {\n  pointer-events: none;\n}\n\n*[dir=\"rtl\"] .itemWithMultiselect__A52ld {\n  margin-left: 10px;\n}\n\n@media screen and (max-width: 599px) {\n  .Dropdown__q-j4p {\n    width: 100%;\n  }\n}\n";
var styles = {"Dropdown":"Dropdown__q-j4p","stretch":"stretch__-Nl-b","l":"l__JFFF0","m":"m__We65K","s":"s__EEErq","SelectionBox":"SelectionBox__xtWZU","invalid":"invalid__gmMCu","placeholder":"placeholder__m4YPi","disabled":"disabled__d3-CY","selection":"selection__2v4Kb","inputFieldWrap":"inputFieldWrap__CvB0G","inputField":"inputField__kfOVU","applyTextColor":"applyTextColor__qLmOU","iconsContainer":"iconsContainer__vcUeh","Popover":"Popover__Vya9r","popBot":"popBot__UMGcE","popTop":"popTop__QIRll","caretIcon":"caretIcon__oY455","emptyState":"emptyState__WrKDO","listbox":"listbox__xIBYn","listItem":"listItem__8-ELC","listWithAvatar":"listWithAvatar__S9P3V","nameWithAvatar":"nameWithAvatar__mhr9h","selectedItemsSpace":"selectedItemsSpace__hGP1P","tagItem":"tagItem__GiVdT","listWithMultiselect":"listWithMultiselect__jxBI1","itemWithMultiselect":"itemWithMultiselect__A52ld","selectedItem":"selectedItem__10mDT","activeItem":"activeItem__6r9mj","disabledItem":"disabledItem__MdN3V"};
var stylesheet=".Dropdown__q-j4p {\n  --dropdown-font-color: var(--text-secondary, hsla(219, 42%, 24%, 1));\n  --dropdown-hover-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  --dropdown-icon-color: var(--icon-primary, hsla(220, 42%, 24%, 1));\n  position: relative;\n  width: 320px;\n  line-height: 1;\n  box-sizing: border-box;\n}\n.Dropdown__q-j4p.stretch__-Nl-b {\n  width: 100%;\n}\n.l__JFFF0 {\n  font-size: var(--body-l, 1.13rem);\n}\n.m__We65K {\n  font-size: var(--body-m, 1rem);\n}\n.s__EEErq {\n  font-size: var(--body-s, 0.88rem);\n}\n.SelectionBox__xtWZU {\n  border: var(--border-width, 1px)\n    var(--interactive-border-solid, solid hsla(220, 22%, 76%, 1));\n  border-radius: var(--roundness-1, 2px);\n  line-height: initial;\n  color: var(--dropdown-font-color);\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  outline: none;\n  background-color: var(--interactive-fill-default, hsla(0, 0%, 100%, 1));\n  cursor: default;\n  box-sizing: border-box;\n}\n\n.SelectionBox__xtWZU.s__EEErq {\n  min-height: 32px;\n  padding: 0.187rem 0.75rem;\n}\n.SelectionBox__xtWZU.m__We65K {\n  min-height: 40px;\n  padding: 0.28rem 0.75rem;\n}\n.SelectionBox__xtWZU.l__JFFF0 {\n  min-height: 48px;\n  padding: 0.375rem 0.75rem;\n}\n\n.SelectionBox__xtWZU:hover {\n  background-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n}\n.SelectionBox__xtWZU:focus,\n.SelectionBox__xtWZU:focus-within {\n  background-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  border-color: var(--interactive-focus, hsla(219, 42%, 18%, 1));\n}\n.SelectionBox__xtWZU.invalid__gmMCu {\n  border-color: var(--interactive-border-support, hsla(12, 92%, 36%, 1));\n}\n.SelectionBox__xtWZU.placeholder__m4YPi {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n}\n.SelectionBox__xtWZU.disabled__d3-CY {\n  background-color: var(--interactive-disabled, hsla(0, 0%, 86%, 1));\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n  border: none;\n  pointer-events: none;\n}\n.Dropdown__q-j4p.disabled__d3-CY {\n  cursor: not-allowed;\n}\n.selection__2v4Kb {\n  overflow: auto;\n}\n.inputFieldWrap__CvB0G {\n  width: 100%;\n}\n.inputField__kfOVU {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: inherit;\n}\n.inputField__kfOVU::-moz-placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU::placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU.applyTextColor__qLmOU::-moz-placeholder {\n  color: var(--dropdown-font-color);\n  opacity: 1;\n}\n.inputField__kfOVU.applyTextColor__qLmOU::placeholder {\n  color: var(--dropdown-font-color);\n  opacity: 1;\n}\n.inputField__kfOVU:focus::-moz-placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU:focus::placeholder {\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  opacity: 1;\n}\n.inputField__kfOVU:disabled::-moz-placeholder {\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n}\n.inputField__kfOVU:disabled::placeholder {\n  color: var(--text-disabled, hsla(0, 0%, 62%, 1));\n}\n.iconsContainer__vcUeh {\n  display: inline-flex;\n  align-items: center;\n}\n.iconsContainer__vcUeh svg path {\n  fill: var(--dropdown-icon-color);\n}\n\n.Popover__Vya9r {\n  --popover-border-radius: var(--roundness-1, 2px);\n  background-color: var(--background-fill-primary, hsla(0, 0%, 100%, 1));\n  width: 100%;\n  padding: 5px 0;\n  z-index: 1;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.Popover__Vya9r.popBot__UMGcE {\n  border-bottom-left-radius: var(--popover-border-radius);\n  border-bottom-right-radius: var(--popover-border-radius);\n  box-shadow: var(--shadow-low, 0px 0px 10px 0px hsla(222, 42%, 6%, 0.1));\n}\n.Popover__Vya9r.popTop__QIRll {\n  border-top-left-radius: var(--popover-border-radius);\n  border-top-right-radius: var(--popover-border-radius);\n  box-shadow: 0 0px 6px 0 hsla(222, 4%, 6%, 0.1);\n}\n.caretIcon__oY455 {\n  font-size: 0;\n}\n.SelectionBox__xtWZU.disabled__d3-CY .caretIcon__oY455 path {\n  fill: var(--icon-disabled, hsla(0, 0%, 62%, 1));\n}\n.emptyState__WrKDO {\n  display: flex;\n  color: var(--text-muted, hsla(219, 23%, 60%, 1));\n  padding: 0.1rem 0.75rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n.listbox__xIBYn {\n  max-height: 180px;\n  overflow-y: auto;\n  list-style-type: none;\n  margin: 0;\n  width: 100%;\n  outline: none;\n  padding: 0;\n  box-sizing: border-box;\n}\n.listItem__8-ELC {\n  width: 100%;\n  --listItem-hover-color: var(--interactive-fill-hover, hsla(216, 24%, 96%, 1));\n  --listItem-selected-color: var(\n    --interactive-fill-active,\n    hsla(220, 17%, 93%, 1)\n  );\n  --listItem-font-color: var(--text-secondary, hsla(219, 42%, 24%, 1));\n  color: var(--listItem-font-color);\n  margin: 0;\n  padding: 8px 16px;\n  cursor: default;\n  box-sizing: border-box;\n}\n.listWithAvatar__S9P3V {\n  display: flex;\n  align-items: center;\n}\n.nameWithAvatar__mhr9h {\n  margin: 0 5px;\n}\n.selectedItemsSpace__hGP1P {\n  background-color: var(--interactive-fill-default, hsla(0, 0%, 100%, 1));\n  height: auto;\n  width: 100%;\n  max-height: 75px;\n  padding-bottom: 5px;\n  margin-bottom: 4px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.tagItem__GiVdT {\n  margin: 2px;\n  display: inline-flex;\n  white-space: nowrap;\n}\n.listWithMultiselect__jxBI1 {\n  display: flex;\n  align-items: center;\n}\n\n/* \n* Pointer events none is added to stop event propagation from checkbox container back to the user \n*/\n\n.itemWithMultiselect__A52ld {\n  pointer-events: none;\n  display: inline-flex;\n  margin-right: 10px;\n}\n.selectedItem__10mDT {\n  background-color: var(--listItem-selected-color);\n}\n.activeItem__6r9mj {\n  background-color: var(--listItem-hover-color);\n}\n.disabledItem__MdN3V {\n  pointer-events: none;\n}\n\n*[dir=\"rtl\"] .itemWithMultiselect__A52ld {\n  margin-left: 10px;\n}\n\n@media screen and (max-width: 599px) {\n  .Dropdown__q-j4p {\n    width: 100%;\n  }\n}\n";
styleInject(css_248z);

const {
  excludeDataAttrs
} = propsUtil;

const openMenuOnEnter = (event, userKeyPress, openMenu) => {
  /* this is done to achive keyboard navigation rules set by w3c for listbox.
  https://w3c.github.io/aria-practices/examples/listbox/listbox-collapsible.html
  */
  if (userKeyPress) {
    userKeyPress(event);
  }

  if (event.charCode === 13) {
    openMenu();
  }
};

const SelectionBox = ({
  openMenu,
  isOpen,
  iconClose,
  iconOpen,
  children,
  referenceRef,
  className,
  placeholder,
  disabled,
  clearSelection,
  typeahead,
  selectedItem,
  multiSelect,
  selectedItemsCount,
  ...props
}) => {
  const inputRef = /*#__PURE__*/React.createRef();
  const SelectionBoxClass = cn([styles.SelectionBox, className], placeholder ? styles.placeholder : null);
  /**
   * Focus the input element
   */

  const focusInput = () => inputRef.current.focus();
  /**
   * Handles the cross icon which renders
   * in case of single dropdown with typeahead
   * @param {object} event
   */


  const handleCross = event => {
    event.stopPropagation();
    clearSelection();
    focusInput();
  };
  /**
   * Invokes Selection Box OnClick
   * which toggles ListBox
   */


  const toggleListBox = () => {
    /* eslint-disable-next-line react/prop-types */
    props.onClick();
  };
  /**
   * Handles the click of the selection Box
   */


  const handleClick = () => {
    if (typeahead) {
      focusInput();
    }

    toggleListBox();
  };
  /**
   * This divides some of the props given by
   * getInputProps of downshift , so that appropriate
   * props are given to the input element and the div
   * element of the selection box in case of dropdown
   * with typeahead
   */

  /* eslint-disable react/prop-types */


  const {
    value,
    autoComplete,
    onBlur,
    onChange,
    onKeyDown,
    id,
    ...typeaheadProps
  } = props;
  /* eslint-enable react/prop-types */

  const typeaheadAndSelectedItems = typeahead && selectedItemsCount > 0 && multiSelect;
  const typeaheadAndSelectedItem = typeahead && selectedItem && !multiSelect;
  /**
   * Decides the placeholder value for input
   * when typeahead.
   */

  const renderInputPlaceholder = () => typeaheadAndSelectedItem ? selectedItem : children;
  /**
   * Toggle the placeholder color according to selectedItems or selectedItem
   * when the focus stateof the selection box changes
   */


  const togglePlaceholderColor = () => typeaheadAndSelectedItems || typeaheadAndSelectedItem ? styles.applyTextColor : null;
  /**
   * Button to clear selection in case of dropdown with typeahead
   */


  const clearButton = () => /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
    size: "s",
    nude: true,
    icon: /*#__PURE__*/React.createElement(Cross, null),
    onClick: handleCross,
    type: "button",
    "aria-label": "clear selection",
    "data-testid": "clear-selection"
  }));
  /**
   * Renders the clear icon in dropdown
   */


  const renderClearButton = () => typeaheadAndSelectedItem ? clearButton() : null;

  const inputClass = cn(styles.inputField, togglePlaceholderColor());

  const getProps = () => {
    return typeahead ? typeaheadProps : props;
  };
  /**
   * Renders the dropdown with a input element wrapped by a
   * respective div element
   */


  const renderWithTypeahead = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.inputFieldWrap,
      onClick: toggleListBox
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: inputClass,
      disabled: disabled,
      placeholder: renderInputPlaceholder(),
      ref: inputRef
    }, excludeDataAttrs(props))));
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: SelectionBoxClass,
    tabIndex: typeahead || disabled ? -1 : 0,
    role: "button",
    "aria-haspopup": "listbox"
    /* eslint-disable-next-line react/prop-types */
    ,
    onKeyPress: e => openMenuOnEnter(e, props.onKeyPress, openMenu),
    ref: referenceRef
  }, getProps(), {
    onClick: handleClick
  }), typeahead ? renderWithTypeahead() : /*#__PURE__*/React.createElement("div", {
    className: styles.selection
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles.iconsContainer
  }, renderClearButton(), /*#__PURE__*/React.createElement("span", {
    className: styles.caretIcon
  }, isOpen ? iconOpen : iconClose)));
};

SelectionBox.propTypes = {
  /**
   * Function to open Dropdown
   */
  openMenu: PropTypes.func.isRequired,

  /**
   * Open state of Dropdown
   */
  isOpen: PropTypes.bool,

  /**
   * Icon to show when Dropdown is closed
   */
  iconClose: PropTypes.element.isRequired,

  /**
   * Icon to show when Dropdown is open
   */
  iconOpen: PropTypes.element.isRequired,

  /**
   * Node which SelectionBox wraps
   */
  children: PropTypes.node.isRequired,

  /**
   * Reference of the Popper Reference Element
   */
  referenceRef: PropTypes.func.isRequired,

  /**
   * external classes to be applied to SelectionBox
   */
  className: PropTypes.string.isRequired,

  /**
   * Hint text for dropdown
   */
  placeholder: PropTypes.bool.isRequired,

  /**
   * disable state of dropdown
   */
  disabled: PropTypes.bool,

  /**
   * Clears the selection
   */
  clearSelection: PropTypes.func,

  /**
   * Current SelectedItem
   */
  selectedItem: PropTypes.string,

  /**
   * Multi-select dropdown
   */
  multiSelect: PropTypes.bool,

  /**
   * Count of selectedItems
   */
  selectedItemsCount: PropTypes.number,

  /**
   * Enables a typeahead / search
   */
  typeahead: PropTypes.bool
};
SelectionBox.defaultProps = {
  disabled: false,
  isOpen: false
};

const ListItem = ({
  active,
  selected,
  children,
  disabled,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("li", _extends({
    role: "option",
    className: cn({
      [styles.activeItem]: active,
      [styles.selectedItem]: selected,
      [styles.disabledItem]: disabled
    }, styles.listItem)
  }, props), children);
};

ListItem.propTypes = {
  /**
   * Active state of item
   */
  active: PropTypes.bool,

  /**
   * Selected state of item
   */
  selected: PropTypes.bool,

  /**
   * Node which ListItem wraps
   */
  children: PropTypes.node.isRequired,

  /**
   * Disabled state of item
   */
  disabled: PropTypes.bool
};

const sizeClass = size => {
  switch (size) {
    case "l":
      return styles.l;

    case "m":
      return styles.m;

    case "s":
      return styles.s;

    default:
      return styles.m;
  }
};
/**
 * Sorts the items according to the value
 *
 * @param items items to be sorted
 * @param value input value to match the items with
 * @param key
 *
 * @returns array of filtered items
 */


const filterList = (items, value, displayKey = "key") => {
  if (value === "") {
    return items;
  }

  return matchSorter(items, value, {
    keys: [displayKey]
  });
};
/**
 * Switches which styles to apply from props
 *
 * @param {object} opts custom props object
 * @returns {string}
 */

const createDropdownClasses = opts => {
  const truthy = [];

  if (opts.invalid) {
    truthy.push(styles.invalid);
  }

  if (opts.disabled) {
    truthy.push(styles.disabled);
  }

  if (opts.size) {
    truthy.push(sizeClass(opts.size));
  }

  if (opts.stretch) {
    truthy.push(styles.stretch);
  }

  return cn(truthy);
};
/**
 * Creates a function to manage downshift's internal state
 *
 * @param {array} items item objects
 * @returns {function} state reducer function
 */

const createStateReducer = (items, multiSelect, typeahead, calcPosition) => (state, changes) => {
  /**
   * Manage internal state
   *
   * @function
   * @inner
   * @param {object} state downshift state
   * @param {object} changes current changes to state
   */

  /**
   * We have to use state.selectedItem for the case when we select an item
   * and then close the list as the last selection is captured in state. Also
   * we have to use changes.selected when the list is open and we are selecting as
   * the latest item is captured in changes.
   */
  const lastSelectAndCloseIndex = state.selectedItem && items.findIndex(item => item.id === state.selectedItem.id);
  const lastSelectAndOpenIndex = changes.selectedItem && items.findIndex(item => item.id === changes.selectedItem.id);

  const openAndSelected = () => {
    if (!changes.isOpen) return false;
    if (lastSelectAndCloseIndex === null) return false;
    return lastSelectAndCloseIndex >= 0 ? true : false;
  };

  const continueSelection = [Downshift.stateChangeTypes.clickItem, Downshift.stateChangeTypes.keyDownEnter];
  const exitSelection = Downshift.stateChangeTypes.blurInput;

  const transformChanges = (changes, values) => {
    return { ...changes,
      ...values
    };
  };

  const stayOpenAndSelect = transformChanges(changes, {
    highlightedIndex: lastSelectAndOpenIndex,
    isOpen: true
  });
  const openAfterSelect = transformChanges(changes, {
    highlightedIndex: lastSelectAndCloseIndex
  });
  const clearInput = transformChanges(changes, {
    inputValue: ""
  });
  /**
   * This is for the case when the user is just selecting
   * normally from the dropdown without typing any value in
   * the feild. So this keeps the highlighted index to the last
   * selected item to make it easy for the user to keep selecting
   */

  const clearAndSelect = transformChanges(stayOpenAndSelect, {
    inputValue: ""
  });
  /**
   * This is for the case when an input value has been provided to the
   * feild and the user is done selecting. So the input is cleared and
   * the highlightedIndex is set to first item so that the user can select
   * from top of the list.
   */

  const clearAndResetIndex = transformChanges(clearAndSelect, {
    inputValue: "",
    highlightedIndex: 0
  });

  if (typeahead) {
    /**
     * To fix repositioning of popover in typeahead.
     * While typing in a flipped list and getting no results,
     * the popover would remain flipped with a gap bw dropdown and popover.
     * calcPosition repositions the popover wrt dropdown here.
     * */
    calcPosition.current && calcPosition.current();

    if (multiSelect) {
      if (continueSelection.includes(changes.type)) {
        calcPosition.current && calcPosition.current();
        return state.inputValue !== "" ? clearAndResetIndex : clearAndSelect;
      }

      if (changes.type === exitSelection) {
        return clearInput;
      }
    }
  }

  if (multiSelect) {
    if (continueSelection.includes(changes.type)) {
      calcPosition.current && calcPosition.current();
      return stayOpenAndSelect;
    }

    if (changes.type === exitSelection) {
      return openAfterSelect;
    }
  } // when opening menu, make sure highlighted index is set to
  // selected index but in case of dropdown with typeahead this is not required


  if (openAndSelected() && !typeahead) {
    return openAfterSelect;
  }

  return changes;
};
/**
 * Handle `escape` key behavior
 *
 * @param {object} event downshift event
 * @param {boolean} isOpen menu open/close state
 * @param {function} closeMenu to close the menu
 */

const handleEscapeKey = (event, isOpen, closeMenu) => {
  if (event.key !== "Escape") return;
  event.nativeEvent.preventDownshiftDefault = true;
  if (isOpen) closeMenu();
};
/**
 * Handle `arrow` keys behavior.
 * Prevent shifting the highlighted index on open
 * and the event propagation to stop browser defaults
 * of moving the page with arrow keys.
 *
 * @param {object} event downshift event
 * @param {boolean} isOpen menu open/close state
 * @param {function} openMenu to open the menu
 */

const handleArrowKeys = (event, isOpen, openMenu) => {
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;

  if (!isOpen) {
    event.preventDefault();
    event.nativeEvent.preventDownshiftDefault = true;
    openMenu();
  }
};
/**
 * Skips effects of useEffect
 * for initial render and uses
 * effects for further renders
 *
 * @param {function} fn function to be called on didUpdate
 * @param  {...any} inputs input(s) that trigger the function
 */

const useDidUpdateEffect = (fn, ...inputs) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current) fn();else didMountRef.current = true;
  }, [...inputs]);
};
/**
 * Accepts items and returns items with `selected` true
 *
 * @param {Array} items
 * @returns array
 */

const filterSelectedItems = items => items.filter(i => Boolean(i.selected));
/**
 * Accepts items and returns first item with `selected` true
 *
 * @param {Array} items
 */

const findSelectedItem = items => items.find(i => Boolean(i.selected));
/**
 * Omits `selected` key from an object.
 *
 * @param {object} input
 * @returns {object}
 */

const omitSelectedKey = input => {
  if (input && input.selected) {
    const {
      selected,
      ...ommitted
    } = input;
    return ommitted;
  }

  return input;
};
/**
 * Applies ordering to selected items using a best suited algorithm
 *
 * The ordering only applies to selected items containing a `selectionOrder`
 * property only. The `selectionOrder` property is expected to be any valid
 * negative or positive integer. Items having lower values of `selectionOrder`
 * is pushed higher in the array followed by items that do not contain a valid
 * `selectionOrder` property at all. The algorithm does not modify the order
 * of items that do not contain the `selectionOrder` property at all.
 *
 * The algorithm works by splitting selected items array into two. One array
 * having all the items that have a valid `selectionOrder` value and another
 * that does not contain a valid `selectionOrder` value. The array with `selectionOrder`
 * is sorted in an ascending order. Finally, the sorted array and the second array
 * containing no `selectionOrder` property is joined and returned. All operations are
 * performed in an immutable fashion.
 *
 * @param {Array}   selectedItems items with `selected` property set as truthy
 * @returns {Array} array of selected items sorted by `selectionOrder` first, followed by rest of the items
 */

const applyOrder = selectedItems => {
  const compare = (a, b) => {
    if (a.selectionOrder < b.selectionOrder) return -1;
    if (a.selectionOrder > b.selectionOrder) return 1;
    return 0;
  };

  const isInteger = ({
    selectionOrder
  }) => Number.isInteger(selectionOrder) === true;

  const isNotInteger = ({
    selectionOrder
  }) => Number.isInteger(selectionOrder) === false;

  const [withoutOrder, withOrder] = [selectedItems.filter(isNotInteger), selectedItems.filter(isInteger)];
  return [...withOrder].sort(compare).concat(withoutOrder);
};

const ListBox = ({
  innerRef,
  children,
  emptyText,
  size,
  ...props
}) => {
  const emptyStateClass = cn(styles.emptyState, createDropdownClasses({
    size
  }));

  const renderEmptyState = () => /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef,
    className: emptyStateClass,
    role: "listbox"
  }, props), emptyText);

  const renderList = () => /*#__PURE__*/React.createElement("ul", _extends({
    ref: innerRef,
    tabIndex: -1,
    role: "listbox",
    className: styles.listbox
  }, props), children);

  return children.length > 0 ? renderList() : renderEmptyState();
};

ListBox.propTypes = {
  /**
   * Reference of ListBox (Menu)
   */
  innerRef: PropTypes.func,

  /**
   * Node which ListBox wraps
   */
  children: PropTypes.node.isRequired
};

const placementClass = (position = "") => {
  return position.includes("top") ? styles.popTop : styles.popBot;
};

const Popover = ({
  placement,
  children,
  popoverRef,
  style,
  elevation
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Popover, placementClass(placement)),
    ref: popoverRef,
    "data-placement": placement,
    style: { ...style,
      zIndex: elevation
    },
    "data-testid": "dropdown-popover"
  }, children);
};

Popover.propTypes = {
  /**
   * describes the placement of the popover
   */
  placement: PropTypes.string,

  /**
   * Node which Popover wraps
   */
  children: PropTypes.node.isRequired,

  /**
   * Reference of the popper element
   */
  popoverRef: PropTypes.func.isRequired,

  /**
   * Computed styles by the popper
   */
  style: PropTypes.object.isRequired,

  /**
   * zIndex of Popover
   */
  elevation: PropTypes.number
};
Popover.defaultProps = {
  elevation: 1
};

/**
 * size values
 */
/**
 * Warning for illegal initialSelectedItems
 */

const illegalItemsWarning = `There might be a mis-match of id's in items and initalSelectedItems`;
/**
 * Warning for illegal initialSelectedItem
 */

const illegalItemWarning = `There might be a mis-match of id's in items and initalSelectedItem`;
/**
 * Warning for having multiple items selected with single select
 */

const multiSelectedKeyWarning = `Multiple items found selected without multiSelect prop applied. Add selected:true only to a single item or apply multiSelect for multi-select dropdown`;
/**
 * Warning for updating items when using `initalSelectedItems` or `initalSelectedItem`
 */

const legacyUpdateModeWarning = `Do not update items when applying initalSelectedItem or initalSelectedItems. To initially select item(s) add a key selected:true to the item(s) passed initially`;
/**
 * Warning for using `reset` with dynamic update mode
 */

const dynamicModeResetWarning = `reset only works with initialSelectedItem or initialSelectedItems. Achieve desired result by updating items dynamically`;

const AvatarItem = ({
  avatar,
  name
}) => {
  const RenderItem = /*#__PURE__*/React.isValidElement(avatar) ? avatar : /*#__PURE__*/React.createElement(Avatar, {
    size: "xxs"
  }, /*#__PURE__*/React.createElement("img", {
    src: avatar.src,
    srcSet: avatar.srcset,
    alt: avatar.alt,
    sizes: avatar.sizes
  }));
  return /*#__PURE__*/React.createElement("span", {
    className: styles.listWithAvatar
  }, RenderItem, /*#__PURE__*/React.createElement("span", {
    className: styles.nameWithAvatar
  }, name));
};

AvatarItem.propTypes = {
  /**
   * avatar to show
   */
  avatar: PropTypes.element.isRequired,

  /**
   * Text rendered with avatar
   */
  name: PropTypes.string.isRequired
};

const SelectableLabel = ({
  avatar,
  checked,
  name,
  disabled
}) => {
  return /*#__PURE__*/React.createElement("span", {
    className: styles.listWithMultiselect
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.itemWithMultiselect
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "m",
    checked: checked,
    onChange: () => null,
    disabled: disabled
  })), avatar ? /*#__PURE__*/React.createElement(AvatarItem, {
    avatar: avatar,
    name: name
  }) : name);
};

SelectableLabel.propTypes = {
  /**
   * avatar to show with the label
   */
  avatar: PropTypes.element,

  /**
   * Text rendered by label
   */
  name: PropTypes.string.isRequired,

  /**
   * checked state of label
   */
  checked: PropTypes.bool.isRequired,

  /**
   * Disables the checkbox
   */
  disabled: PropTypes.bool
};

const Label = ({
  avatar,
  name
}) => {
  return avatar ? /*#__PURE__*/React.createElement(AvatarItem, {
    avatar: avatar,
    name: name
  }) : name;
};

Label.propTypes = {
  /**
   * avatar to show with the label
   */
  avatar: PropTypes.element,

  /**
   * Text rendered by label
   */
  name: PropTypes.string.isRequired
};

const {
  yieldDataAttrs
} = propsUtil;
const Dropdown = /*#__PURE__*/React.forwardRef(({
  items,
  placeholder,
  onChange,
  onInput,
  size,
  stretch,
  defaultHighlightedIndex,
  initialSelectedItem,
  initialSelectedItems,
  initialIsOpen,
  elevation,
  invalid,
  disabled,
  displayKey,
  multiSelect,
  flip,
  filter,
  translate,
  id,
  labelId,
  resetRef,
  typeahead,
  emptyText,
  tags,
  ...props
}, ref) => {
  //Send styles to server
  sendStyles(stylesheet);
  const [dynamicMode, setDynamicMode] = React.useState(false);
  /**
   * To check if `initialSelectedItem` or `initalSelectedItems` prop are being passed
   */

  const dynamicUpdateMode = !(initialSelectedItem || initialSelectedItems.length);
  /**
   * Check legality of initalSelectedItem
   */

  const legalizeInitialSelectedItem = () => {
    const matchId = item => item.id === initialSelectedItem.id;

    const legalItem = items.find(matchId);

    if (!legalItem) {
      console.warn(illegalItemWarning);
      return null;
    }

    return legalItem;
  };
  /**
   * Return selected item according to the `selected` key
   *
   * @param {array} items
   * @returns {object | null}
   */


  const fetchDynamicSelectedItem = items => {
    if (!multiSelect && filterSelectedItems(items).length > 1) {
      console.warn(multiSelectedKeyWarning);
      return;
    }

    return findSelectedItem(items) || null;
  };
  /**
   * When the user passes initalSelectedItem it takes precedence over
   * `selected` key in items and item is set as selected initally
   * after a legalization check. In other case if any item contains
   * `selected` key the first is set as selected initally for the first render
   */


  const allocateInitialSelectedItem = () => initialSelectedItem ? legalizeInitialSelectedItem() : fetchDynamicSelectedItem(items);

  const legalInitialSelectedItem = allocateInitialSelectedItem();
  const [currentSelectedItem, setCurrentSelected] = React.useState(legalInitialSelectedItem);
  /**
   * Check legality of initalSelectedItems
   */

  const legalizeInitialSelectedItems = () => {
    const legalItems = initialSelectedItems.reduce((acc, {
      id
    }) => {
      const legalItem = items.filter(({
        id: itemId
      }) => itemId === id);

      if (legalItem.length) {
        acc.push(legalItem[0]);
      }

      return acc;
    }, []);
    if (legalItems.length !== initialSelectedItems.length) console.warn(illegalItemsWarning);
    return legalItems;
  };
  /**
   * When the user passes initalSelectedItems it takes precedence over
   * `selected` key in items and those items are set as selected initally
   * after a legalization check. In other case items containing
   * `selected` key are set as selected initally for the first render
   */


  const allocateInitialSelectedItems = () => initialSelectedItems.length ? legalizeInitialSelectedItems() : filterSelectedItems(items);

  const legalInitialSelectedItems = allocateInitialSelectedItems();
  const [selectedItems, setSelectedItems] = React.useState([...legalInitialSelectedItems]);
  /**
   * Dynamically update `selectedItems` or `currentSelectedItem` according to
   * value of the `selected` key of each item(s). Also set dynamicMode to true when
   * items are updated. Function is wrapped with `useCallback` with a
   * dependency list because the function is invoked in useEffect and might
   * have some side effects if not followed.
   */

  const updateItemsFunction = React.useCallback(() => {
    if (!dynamicUpdateMode) {
      console.warn(legacyUpdateModeWarning);
      return;
    }

    setDynamicMode(true);

    if (multiSelect) {
      setSelectedItems(filterSelectedItems(items));
      setCurrentSelected(null);
    } else {
      setCurrentSelected(fetchDynamicSelectedItem(items));
    }
  }, [dynamicUpdateMode, multiSelect, fetchDynamicSelectedItem, items]);
  /**
   * Update items after the inital render when the items prop is updated
   */

  useDidUpdateEffect(updateItemsFunction, items);
  /**
   * This is a reference to scheduleUpdate function from react-popper.
   * We need to manually trigger updates for popover position after some events.
   */

  const calcPosition = React.useRef(null);
  /**
   * Return options object
   * @returns object
   */

  const createOpts = () => {
    const opts = {};
    if (selectedItems && multiSelect) opts.selectedItems = selectedItems.map(i => omitSelectedKey(i));
    if (ref && ref.current) opts.ref = ref;
    return opts;
  };
  /**
   * Calls user provided onChange function
   * with first arg as the current selectedItem
   * and an options object. Function is wrapped with `useCallback` with a
   * dependency list because the function is invoked in useEffect and might
   * have some side effects if not followed.
   */


  const callUserOnChange = React.useCallback(() => {
    if (!onChange || dynamicMode) return null;
    const opts = createOpts();
    onChange(omitSelectedKey(currentSelectedItem), opts);
  }, [onChange, currentSelectedItem, selectedItems]);
  /**
   * Call user onChange
   */

  useDidUpdateEffect(callUserOnChange, currentSelectedItem, selectedItems);
  /**
   * Checks if the item is present in selectedItems
   * @param {object} item
   * @returns {boolean}
   */

  const anyItemSelected = item =>
  /* eslint-disable-next-line react/prop-types */
  selectedItems.some(({
    id
  }) => id === item.id);
  /**
   * Add item to selectedItems
   * @param {object} item
   */


  const addItem = item => setSelectedItems([...selectedItems, item]);
  /**
   * Remove item from selectedItems
   * @param {object} item
   */


  const removeItem = item =>
  /* eslint-disable-next-line react/prop-types */
  setSelectedItems(selectedItems.filter(({
    id
  }) => id !== item.id));
  /**
   * Handle Selection of SelectableLabel
   * @param {object} item
   */


  const handleSelectableLabel = item => {
    if (anyItemSelected(item)) {
      removeItem(item);
    } else {
      addItem(item);
    }
  };
  /**
   * Handles selection of any Label and set dynamicMode to false
   * @param {object} item
   */


  const handleLabelSelection = item => {
    setDynamicMode(false);
    setCurrentSelected(item);

    if (multiSelect) {
      handleSelectableLabel(item);
    }
  };
  /**
   * Handle TagItem dismiss
   * @param {object} item
   */


  const handleTagDismiss = item => {
    if (!disabled) {
      handleLabelSelection(item);
    }
  };

  const TagItem = ({
    item
  }) => /*#__PURE__*/React.createElement("div", {
    className: styles.tagItem
  }, /*#__PURE__*/React.createElement(Tag, {
    size: "m",
    dismissible: !disabled,
    onDismiss: () => handleTagDismiss(item),
    "data-testid": "selected-tag"
  }, item[displayKey]));
  /**
   * disabled has been set to both the Dropdown and selectionBox for consistent styling
   * in disabled state. As selectionBox has pointer-events: none so we need to provide cursor: not-allowed
   * to Dropdown to enable the desired behaviour.
   */
  // These are the properties that are controlled by the selection box


  const selectionBoxClass = createDropdownClasses({
    size,
    invalid,
    disabled
  }); // The main div controls the width.

  const mainDivClass = cn(styles.Dropdown, createDropdownClasses({
    stretch,
    disabled
  }));
  /**
   * Call user translate function if provided
   * or return default implementation
   * @param {number} length
   */

  const handleTranslate = length => {
    return translate ? translate(length) : `${length} Selected`;
  };
  /**
   * Decides what is rendered inside SelectionBox
   * @param {object} selectedItem
   */

  /**
   * Decides which Label to render as ListItem
   * @param {object} input
   */


  const renderListItem = input => {
    if (multiSelect) {
      return /*#__PURE__*/React.createElement(SelectableLabel, {
        avatar: input.avatar,
        name: input[displayKey],
        checked: anyItemSelected(input),
        disabled: disabled
      });
    }

    return /*#__PURE__*/React.createElement(Label, {
      avatar: input.avatar,
      name: input[displayKey]
    });
  };

  const renderSelectionBox = selectedItem => {
    if (multiSelect) {
      return selectedItems.length ? handleTranslate(selectedItems.length) : placeholder;
    }

    return selectedItem ? renderListItem(selectedItem) : placeholder;
  };
  /**
   * Displays selected items as a list of Tag components
   * after applying an ordering algorithm
   */


  const renderSelected = () => applyOrder(selectedItems).map((item, index) => /*#__PURE__*/React.createElement(TagItem, {
    item: item,
    key: index
  }));
  /**
   * Handle Outer Click on MultiSelect with typeahead
   */


  const handleOuterClick = object => {
    if (multiSelect && typeahead) {
      return object.setState({
        inputValue: ""
      });
    }
  };
  /**
   * Handles the selected prop of ListItem
   * @param {object} item
   * @param {object} selectedItem
   * @returns {boolean}
   */


  const itemSelected = (item, selectedItem) => {
    /* eslint-disable-next-line react/prop-types */
    const selected = selectedItem && selectedItem.id === item.id;
    const selectedMulti = selected && selectedItems.includes(item);

    if (multiSelect) {
      return selectedMulti;
    }

    return selected;
  };
  /**
   * Renders the item list
   *
   * If the dropdown resets or a deprecating prop is passed
   * returns current/old set of items else returns updated items
   * in the list
   *
   * @param {Array} items original item collection
   * @param {String} inputValue keyword to filter on
   * @param {Boolean} append append non-matched items to the filtered list
   */


  const renderItemList = (items, inputValue, append = false) => {
    const filtered = filterList(items, inputValue, displayKey);

    if (!append) {
      return filtered;
    }

    const rest = items.filter(({
      id
    }) => {
      var _filtered$find;

      return ((_filtered$find = filtered.find(f => f.id === id)) === null || _filtered$find === void 0 ? void 0 : _filtered$find.id) !== id;
    });
    return filtered.concat(rest);
  };
  /**
   * In case of multiSelect and typeahead the selectedItem state of downshift is not updated.
   * This is done on purpose, because the inputValue is controlled by selectedItem's value which if
   * updated as other cases will break the previous selection behaviour of Dropdown. This does
   * not affect the user as the user is still gets expected results.
   */


  const selectedController = multiSelect && typeahead ? null : currentSelectedItem;
  const dataAttrs = yieldDataAttrs(props);

  const inputHandler = e => onInput === null || onInput === void 0 ? void 0 : onInput(e);

  return /*#__PURE__*/React.createElement(Downshift, {
    defaultHighlightedIndex: typeahead ? 0 : defaultHighlightedIndex,
    itemToString: item => item ? item[displayKey] : "",
    stateReducer: createStateReducer(items, multiSelect, typeahead, calcPosition),
    initialSelectedItem: legalInitialSelectedItem,
    initialIsOpen: initialIsOpen,
    onSelect: item => handleLabelSelection(item),
    id: id,
    labelId: labelId,
    onOuterClick: handleOuterClick,
    supplementary: {
      multiSelect,
      initialSelectedItems: legalInitialSelectedItems,
      selectedItems,
      setSelectedItems,
      setCurrentSelected,
      dynamicUpdateMode
    },
    selectedItem: selectedController,
    ref: resetRef
  }, ({
    getInputProps,
    getItemProps,
    getMenuProps,
    isOpen,
    openMenu,
    closeMenu,
    toggleMenu,
    highlightedIndex,
    selectedItem,
    clearSelection,
    inputValue
  }) => {
    const renderListBox = () => {
      const itemList = typeahead ? renderItemList(items, inputValue, !filter) : items;
      return /*#__PURE__*/React.createElement(ListBox, _extends({}, getMenuProps({
        refKey: "innerRef",
        "aria-multiselectable": Boolean(multiSelect),
        "data-testid": "listbox"
      }), {
        emptyText: emptyText,
        size: size
      }), itemList.map((item, index) => /*#__PURE__*/React.createElement(ListItem, _extends({
        key: index
      }, getItemProps({
        key: index,
        index,
        item,
        active: highlightedIndex === index && !disabled,
        selected: !disabled && itemSelected(item, selectedItem),
        disabled
      })), renderListItem(item))));
    };

    return /*#__PURE__*/React.createElement("div", _extends({
      className: mainDivClass,
      "aria-disabled": disabled
    }, dataAttrs), tags && multiSelect && selectedItems.length ? /*#__PURE__*/React.createElement("div", {
      className: styles.selectedItemsSpace,
      onClick: closeMenu,
      "data-testid": "selected-items"
    }, renderSelected()) : null, /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, refProps => /*#__PURE__*/React.createElement(SelectionBox, _extends({}, getInputProps({
      "data-testid": "selection-box",
      onInput: inputHandler,
      onKeyDown: event => {
        handleEscapeKey(event, isOpen, closeMenu);
        handleArrowKeys(event, isOpen, openMenu);
      }
    }), {
      onClick: toggleMenu,
      isOpen: isOpen,
      iconClose: /*#__PURE__*/React.createElement(CaretDown, null),
      iconOpen: /*#__PURE__*/React.createElement(CaretUp, null),
      openMenu: openMenu,
      referenceRef: refProps.ref,
      className: selectionBoxClass,
      placeholder: !(selectedItem || selectedItems.length),
      disabled: disabled,
      typeahead: typeahead,
      clearSelection: clearSelection,
      selectedItem: selectedItem ? selectedItem[displayKey] : null,
      multiSelect: multiSelect,
      selectedItemsCount: selectedItems.length
    }), renderSelectionBox(selectedItem))), isOpen ? /*#__PURE__*/React.createElement(Popper, {
      placement: "bottom-start",
      modifiers: {
        preventOverflow: {
          escapeWithReference: true
        },
        flip: {
          enabled: !multiSelect && flip
        }
      }
    }, ({
      ref,
      style,
      placement,
      scheduleUpdate
    }) => {
      calcPosition.current = scheduleUpdate;
      return /*#__PURE__*/React.createElement(Popover, {
        popoverRef: ref,
        style: style,
        placement: placement,
        elevation: elevation
      }, renderListBox());
    }) : null));
  });
});
Dropdown.displayName = "Dropdown";
Dropdown.propTypes = {
  /**
   * Array of Objects that dropdown renders
   *
   * ```js
   * items = [{ id: "1", key: "jakarta", ...]
   * ```
   *
   * Complete shape of each object may look like:
   *
   * ```js
   * {
   *    id: "string-to-uniquely-identify-the-item",
   *    key: "DisplayValue",
   *    selected: false     // true if this item should be selected
   *    selectionOrder: 0   // a valid integer to specify the order
   * }
   * ```
   *
   * Out of the above only `id` is required. Typically, at the least, provide `id`
   * and `key`.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    key: PropTypes.string,
    selected: PropTypes.bool,
    selectionOrder: PropTypes.number
  }).isRequired).isRequired,

  /**
   * Hint text to show when no item is selected
   */
  placeholder: PropTypes.string,

  /**
   *
   * Called when selected item changes by user interaction or the Dropdown resets.
   * It receives multiple arguments with the following signature
   *
   * - item - item selected by user interaction
   * - options(object) - `selectedItems` key gives an array of selectedItems when multiSelect
   *
   * ```js
   *  (item, options) => void
   * ```
   *
   */
  onChange: PropTypes.func,

  /**
   * Callback to handle user input in a `typeahead` enabled Dropdown. It receives the React synthetic event as the argument.
   *
   * ```js
   * (event) => {}
   * ```
   */
  onInput: PropTypes.func,

  /**
   * Renders the component with the provided size. accepts s, m, l for small, medium & large
   */
  size: PropTypes.oneOf(["s", "m", "l"]),

  /**
   * Stretches the component width to match its container
   */
  stretch: PropTypes.bool,

  /**
   * This is the index value of an item which will be highlighted when Dropdown is initialized or reset
   */
  defaultHighlightedIndex: PropTypes.number,

  /**
   * Item which should be pre-selected on initialization. Applies for the first render only.
   *
   * **Note**: _This prop is going to be deprecated in next major version_
   */
  initialSelectedItem: PropTypes.object,

  /**
   * Items which should be pre-selected for multiSelect on initialization. Applies for the first render only.
   *
   * **Note**: _This prop is going to be deprecated in next major version_
   */
  initialSelectedItems: PropTypes.arrayOf(PropTypes.object),

  /**
   * Opens Dropdown on initialization
   */
  initialIsOpen: PropTypes.bool,

  /**
   * z-index of list box
   */
  elevation: PropTypes.number,

  /**
   * Disables the Dropdown
   */
  disabled: PropTypes.bool,

  /**
   * Applies invalid styles to the Dropdown
   */
  invalid: PropTypes.bool,

  /**
   *
   * Key property name of the items, the key property's value will be shown as the list item
   */
  displayKey: PropTypes.string,

  /**
   * Dropdown flip according to viewport boundary
   */
  flip: PropTypes.bool,

  /**
   * Don't show unmatched typeahead items
   *
   * When typeahead is applied, only the matching items will show up in the list.
   * Passing `false` will instead show all the unmatched items after the matched items
   * in the list. This way, you can control if all items are shown in the list or not.
   * As a consequence, if filter is false, then the empty state will never appear.
   *
   * filter has no effect when `typeahead={false}`
   */
  filter: PropTypes.bool,

  /**
   * Enables multiple item selection
   */
  multiSelect: PropTypes.bool,

  /**
   * Function to show custom text in selectionBox in multiSelect
   */
  translate: PropTypes.func,

  /**
   * DOM id of the Dropdown
   */
  id: PropTypes.string,

  /**
   * Id of the label used for Dropdown. Used for aria attributes.
   */
  labelId: PropTypes.string,

  /**
   * Custom reference for reset.
   *
   *_`reset` does not clear the Dropdown.
   * It resets the Dropdown to its first render.
   * Only works with `initialSelectedItem` or `initialSelectedItems`_
   *
   * **Note**: _This prop is going to be deprecated in next major version_
   */
  resetRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /**
   * Enables filtering of matched items based on typed keywords.
   * The [matching algorithm](https://github.com/kentcdodds/match-sorter) used
   * gives the end user the best possible user experience.
   */
  typeahead: PropTypes.bool,

  /**
   * Show custom text when no result is found
   */
  emptyText: PropTypes.string,

  /**
   * Shows the selected items as tags above a `multiselect` dropdown.
   *
   * > from v1.20.0+
   */
  tags: PropTypes.bool
};
Dropdown.defaultProps = {
  size: "m",
  stretch: false,
  placeholder: "Select",
  elevation: 1,
  displayKey: "key",
  disabled: false,
  defaultHighlightedIndex: 0,
  flip: true,
  filter: true,
  multiSelect: false,
  initialIsOpen: false,
  initialSelectedItems: [],
  typeahead: false,
  emptyText: "No Results Found.",
  tags: true
};

/**
 * This is a highly experimental function which enables the user to reset the dropdown
 * to it's initial state.
 *
 * @param {function} ref reference of dropdown to reset
 *
 */

const reset = ref => {
  if (!ref || !ref.current) return;
  /**
   * downshift props
   */

  const {
    initialSelectedItem,
    initialIsOpen,
    defaultHighlightedIndex,
    inputValue
  } = ref.current.props;
  /**
   * supplementary props
   */

  const {
    multiSelect,
    initialSelectedItems,
    setSelectedItems,
    setCurrentSelected,
    dynamicUpdateMode
  } = ref.current.props.supplementary;
  /**
   * This function informs the dropdown
   * when `reset` is called
   */

  const handleMultiReset = () => {
    setSelectedItems([...initialSelectedItems]);
    setCurrentSelected(null);
  };

  if (dynamicUpdateMode) {
    console.warn(dynamicModeResetWarning);
  }
  /**
   * Downshift's `selecteditems` is now controlled.
   *
   */


  const handleReset = () => {
    setCurrentSelected(initialSelectedItem || null);
    ref.current.reset({
      highlightedIndex: defaultHighlightedIndex ? defaultHighlightedIndex : null,
      isOpen: initialIsOpen,
      inputValue: inputValue || ""
    });
  };

  if (multiSelect) {
    handleMultiReset();
  } else {
    handleReset();
  }
};

export { Dropdown as default, reset };
